import React from "react";
import ViewLineups from "../ViewLineups";

import { graphql, useLazyLoadQuery } from "react-relay";

const GET_LINEUPS = graphql`
  query LineupsDisplayQuery($lineupSetId: ID!) {
    ...ViewLineups_query @arguments(lineupSetId: $lineupSetId)
  }
`;

export default function LineupsDisplay(props) {
  const queryOptions = {
    fetchPolicy: "network-only",
  };

  const data = useLazyLoadQuery(
    GET_LINEUPS,
    {
      lineupSetId: props.lineupSetID,
    },
    queryOptions
  );

  return (
    <ViewLineups
      lineupSetID={props.lineupSetID}
      refetch={props.refetch}
      numRefetches={props.numRefetches}
      query={data}
    />
  );
}
